/** localStorage can throw (private mode, blocked storage); every access is guarded. */
export const readSetting = (key: string): string | null => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export const writeSetting = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Storage is a convenience here, never required.
  }
}
